<template>

  <div>
    <el-row class="km" :gutter="20">
      <el-col class="leftWrap" :span="7">
        <div class="box">
          <el-input placeholder="输入模板名称后回车搜索" @keyup.enter.native="onSearch" v-model="filter.name" clearable
            @clear="onSearch"></el-input>
          <el-button icon="el-icon-search" @click="onSearch">搜索</el-button>
        </div>
        <div class="infinite-list" v-infinite-scroll="onLoadMore" infinite-scroll-disabled="disabled"
          style="overflow: auto">
          <el-menu class="el-menu-vertical-demo" @select="onSelect">
            <el-menu-item v-for="item in items" :key='item.id' :index="item.id.toString()">
              <span slot="title">{{ item.name }}</span>
            </el-menu-item>
          </el-menu>
        </div>
      </el-col>

      <el-col :span="17">
        <div class=" table-wrap" v-if="detailFlag">
          <div class="title">
            <p>{{ list.templateScheduleName }}</p>
            <el-button type="primary" size="mini" round @click="copyTempate">复制此模板</el-button>
          </div>
          <el-table ref="multipleTable" header-cell-class-name="tab-cell" cell-class-name="tab-cell" border
            :data="list.templateScheduleInfoDetailVOS" v-loading="isLoading">
            <!-- <el-table-column fixed="left" type="selection" width="50"></el-table-column> -->
            <el-table-column prop="templateNum" label="随访次数" width="100"></el-table-column>
            <el-table-column prop="templateContent" label="随访建议" show-overflow-tooltip></el-table-column>
            <el-table-column prop="dateNum" label="随访间隔" width="100"></el-table-column>
            <el-table-column prop="dateUnitName" label="间隔单位" width="100"></el-table-column>
          </el-table>
          <div v-if="loading" style="color: #bbb; text-align: center">
            加载中...
          </div>
          <div v-if="noMore" style="color: #bbb; text-align: center">
            没有更多数据
          </div>
        </div>
      </el-col>
      <el-dialog class="template-form" title="复制模板" width="760px" center :visible.sync="copyFlag.active"
        :close-on-click-modal="false">
        <el-form ref="form" label-width="120px" :rules="copyFlag.rules" :model="form">
          <el-form-item label="科室权限" prop="departmentId">
            <el-select filterable clearable v-model="form.departmentId" placeholder="请选择科室">
              <el-option v-for="item in deptList" :key="item.id" :label="item.name" :value="item.id"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="模板类型" prop="autoState">
					<el-select filterable clearable v-model="form.autoState" placeholder="请选择模板类型" >
						<el-option v-for="item in [{ id: 1, name: '自动排期模板' }, { id: 2, name: '手动排期模板' }]" :key="item.id" :label="item.name" :value="item.id"></el-option>
			
					</el-select>
				</el-form-item>
				<el-form-item v-if="form.autoState==1" label="疾病标签" prop="tagIds">
					<el-transfer :titles="['全部疾病标签', '已选疾病标签']" :props="{key: 'tagId', label: 'tagName' }" :data="diseaseTagList" v-model="form.tagIds"></el-transfer>
				</el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button type="primary" :loading="isLoading" @click="saveTemplate">保 存</el-button>
        </div>
        <div class="mask"></div>
      </el-dialog>
    </el-row>
    <!-- </el-drawer> -->
  </div>
</template>

<script>
import api from '@/service/api.js';
import infiniteScroll from "@/directive/infinite-scroll";

export default {
  directives: { infiniteScroll },
  //   components: { SubMenu },
  props: {
    visible: Boolean,
    deptList: {
      require: true
    }
  },
  computed: {
    noMore() {
      return this.filter.pageNumber * this.filter.pageSize >= this.filter.total;
    },
    disabled() {
      return this.page > this.total;
    },
  },
  data() {
    return {
      loading: false,
      filter: {//list
        pageNumber: 0,
        pageSize: 15,
        total: 1,
        name: '',
        departmentId: 0,
      },
      mode: "",
      page: 1,
      total: 2,
      items: [],
      menu: undefined,
      templateId: null,
      form: {//save
        templateId: 0,
        departmentId: this.deptList[0].id,
        autoState:2,
        tagIds:[]
      },
      para: {//详情
        templateId: 0,
        pageNumber: 1,
        pageSize: 10
      },
      list: {},
      isLoading: false,
      detailFlag: false,
      copyFlag: {
        active: false,
        rules: {
          name: { required: true, message: '请输入模板名', trigger: 'blur' },
          departmentId: { required: true, message: '请选择科室', trigger: 'change' },
          autoState: {required: true, message: '请选择模板类型', trigger: 'change'},
					tagIds : {required: true, message: '请选择疾病标签', trigger: 'change'}
        }
      },
      diseaseTagList: undefined,
			diseaseTag: [],


    };
  },
  async mounted() {
    let res = await api.getScheduleTemplate(this.filter);
    this.menu = res.data;
    this.loadPatientAllTag()
  },
  methods: {
    reset() {
      this.filter = {
        pageNumber: 0,
        pageSize: 15,
        total: 1,
        name: '',
        departmentId: 0,
      }
      this.para.templateId = null;
      this.detailFlag = false;
      this.items = [];
      this.onLoadMore()
    },
    async loadPatientAllTag() {
			let res = await api.getPatientAllTag();
			if (res.code === 1000) {
				if (res.data.diseaseTagList) {
					this.diseaseTagList = res.data.diseaseTagList;
				}
			}
		},
    onSelect(data) {
      this.para.templateId = data;
      this.detailFlag = data;
      this.isLoading = true;
      this.getDetail();
      this.isLoading = false;
    },
    selectionChange(selected) {
      console.log(selected, '----sss');
      let selection = []
      selected.forEach((item) => {
        selection.push(item.id);
      })
      this.multipleSelection = selection;
    },
    async getDetail() {
      let res = await api.getScheduleTemplateInfoById(this.para);
      this.list = res.data;
    },
    async copyTempate() {

      this.copyFlag.active = true;
      this.form.autoState =2;
			this.form.tagIds = [];
      this.form.departmentId=this.deptList[0].id

    },
    async saveTemplate() {
      this.$refs['form'].validate(async (valid) => {
        if (valid) {
          let res = await api.copyTemplate({
            departments: this.form.departmentId,
            id: this.para.templateId,
            autoState:this.form.autoState,
            tagIds:this.form.tagIds
          })
          if (res.code == 1000) {
            this.$emit('custom-event');
            this.$message({ message: '复制成功', type: 'success' });
            this.copyFlag.active = false;
          }
        }
      })
    },
    async onLoadMore() {
      let res;
      if (this.loading) {
        return false;
      }
      if (this.filter.pageNumber * this.filter.pageSize > this.filter.total) {
        return false;
      }
      this.filter.pageNumber++;
      this.loading = true;
      res = await api.getScheduleTemplate(this.filter);
      this.loading = false;
      this.filter.total = res.total;
      this.items = this.items.concat(res.data);
    },
    async onSearch() {
      this.filter.pageNumber = 0;
      this.items = [];
      this.onLoadMore();
    },
  },
};
</script>

<style lang="less" scoped>
@import '@/assets/style/var';

.leftWrap {
  height: 100%;
  overflow: auto;
  display: flex;
  flex-direction: column;
}

.infinite-list {
  height: calc(100vh - 180px);
  overflow: auto;
}

.title {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0 32px;

  .el-button {
    height: 28px;
  }

  p {
    font-size: 16px;
  }
}

.template-form {
  background: rgba(0, 0, 0, .5);

  .mask {
    width: 100%;
    height: 100%;
    z-index: -1;
    background: red;
  }

  .el-form {
    .el-textarea {
      width: 100%;
    }

    .el-input {
      width: 160px;
      margin-right: 20px;
    }

    .el-select {
      .el-input {
        width: 140px;
      }
    }

  }
}</style>